module.exports = __webpack_public_path__ + "img/free_multiplier_10.544d8797.png";